import { getLocale } from "../runtime";

const sv_youwillgetaorderconfirmation = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Du får en orderbekräftelse till din e-post inom 30min.`
};

const youwillgetaorderconfirmation = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_youwillgetaorderconfirmation(inputs)
	return "youWillGetaOrderConfirmation";
};

export { youwillgetaorderconfirmation as "youWillGetaOrderConfirmation" };